import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Icon from './AppIcon';

/**
 * Dismissible info banner shown on public screens to unauthenticated users,
 * prompting them to sign in for full features.
 */
const SignInPromptBanner = ({ message = 'Sign in to save verses, add notes, and access all study features.' }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(false);

  if (user || dismissed) return null;

  return (
    <div className="w-full bg-blue-50 border border-blue-200 rounded-lg dark:bg-blue-950/30 dark:border-blue-800 mb-3">
      <div className="px-3 py-2.5 flex items-center justify-between gap-2">
        <div className="flex items-center gap-2 flex-1 min-w-0">
          <Icon name="Info" size={15} className="text-blue-500 dark:text-blue-400 shrink-0" />
          <p className="text-xs text-blue-800 dark:text-blue-300 leading-snug">
            {message}
          </p>
        </div>
        <div className="flex items-center gap-1.5 shrink-0">
          <button
            onClick={() => navigate('/login')}
            className="text-xs font-semibold px-2.5 py-1 rounded-md bg-blue-600 hover:bg-blue-700 text-white transition-colors"
          >
            Sign In
          </button>
          <button
            onClick={() => setDismissed(true)}
            className="p-1 text-blue-400 hover:text-blue-600 dark:hover:text-blue-300 transition-colors"
            aria-label="Dismiss"
          >
            <Icon name="X" size={13} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignInPromptBanner;
